// src/components/Navbar8.js
import React from "react";
import { XCircle } from "lucide-react";

const Navbar8 = ({ onClose, onSave, isSaving = false }) => (
  <nav className="bg-white border-b p-4 md:p-6 flex items-center justify-between">
    <h1 className="text-xl font-bold text-black">Add Media</h1>

    <div className="flex items-center space-x-4">
      <button 
        onClick={onSave}
        className={`px-4 py-1 ${
          isSaving ? "bg-gray-500" : "bg-black hover:bg-gray-800"
        } text-white rounded transition-colors`}
        title="Save changes"
        disabled={isSaving}
      >
        {isSaving ? "Saving..." : "Save"}
      </button>

      <button
        onClick={onClose}
        className="text-gray-600 hover:text-black transition-colors duration-200"
        title="Close without saving"
      >
        <XCircle size={24} />
      </button>
    </div>
  </nav>
);

export default Navbar8;